module.exports = __webpack_public_path__ + "static/media/login-prm-pic2.4b419bff.jpg";